import { cn } from "@/shared/utils/cn";
import { OrderStatusTypes } from "../../shared/utils/interfaces";

interface OrderStatusProps {
  status: OrderStatusTypes;
  active: boolean;
  onClick: () => void;
  index?: number;
  isLast?: boolean;
}

const OrderStatue = ({
  onClick,
  active = false,
  status = "Nieuw",
  index,
}: OrderStatusProps) => {
  return (
    <div
      className={cn(
        "flex items-center gap-4 min-w-0 shrink-0",
        index === 2 ? "md:flex-2" : "md:flex-1"
      )}
    >
      <button
        onClick={onClick}
        className={cn(
          "group border-2 flex items-center gap-0 cursor-pointer transition-all duration-200 focus:outline-none flex-1 min-w-0 rounded-lg",
          active
            ? "opacity-100 border-primary"
            : "opacity-55 hover:opacity-80 hover:border-primary"
        )}
      >
        <div
          className={cn(
            "flex items-center justify-center size-14 transition-all duration-200 shrink-0"
          )}
        >
          <div
            className={cn(
              "rounded-full transition-all duration-200",
              active
                ? "size-5 bg-primary"
                : "size-4 bg-grey group-hover:bg-primary"
            )}
          />
        </div>

        <div
          className={cn(
            "flex items-center justify-center flex-1 min-w-0 h-14 px-4 text-2xl font-bold transition-all duration-200 truncate",
            active
              ? "bg-primary text-white shadow-md"
              : "bg-grey text-dark group-hover:bg-primary/10 group-hover:text-primary"
          )}
        >
          {status}
        </div>
      </button>
    </div>
  );
};

export default OrderStatue;
